import { useEffect, useState } from "react";
import Container from "@/components/Container";
import Pager, { usePager } from "@/components/Pager";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";

export default function SavedSearches() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/saved-searches").then(r => setItems(r.data || [])).catch(() => {});
  useEffect(() => { load(); }, []);
  const del = async (id) => {
    if (!window.confirm("Delete saved search?")) return;
    await api.delete(`/saved-searches/${id}`); toast.success("Deleted"); load();
  };
  const pager = usePager(items);
  return (
    <Container className="py-8 md:py-12">
      <p className="overline">Discovery</p>
      <h1 className="mt-2 text-4xl md:text-5xl font-serif text-ivory">Saved Searches</h1>
      <div className="mt-8 luxury-card divide-y divide-charcoal-600/60">
        {items.length === 0 && <p className="p-8 text-center text-ivory/40 text-sm">No saved searches yet. Create them from the Search Engine.</p>}
        {pager.pageItems.map(s => (
          <div key={s.id} className="p-5 flex items-center justify-between gap-4" data-testid={`saved-search-${s.id}`}>
            <div className="flex-1">
              <p className="text-ivory font-medium">{s.name}</p>
              <p className="text-xs text-ivory/50 mt-1">{s.country} {s.city ? `· ${s.city}` : ""} · {s.keywords?.length || 0} keywords · {s.source_domains?.length || 0} domains</p>
              <p className="text-[0.65rem] text-ivory/40 mt-1 font-mono">{s.generated_queries?.length || 0} queries</p>
            </div>
            <button onClick={() => del(s.id)} className="btn-outline !py-2 !px-3"><Trash2 size={14} /></button>
          </div>
        ))}
      </div>
      <Pager {...pager} testid="saved-searches-pager" />
    </Container>
  );
}
